import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { useState } from "react";
import WithdrawPopupStart from "./WithdrawPopupStart";
import WithdrawPopupSuccess from "./WithdrawPopupSuccess";
import WithdrawPopupFail from "./WithdrawPopupFail";
import ModalWindow from "components/ModalWindow";

const WithdrawPopup = ({close}) => {
  const [step, setStep] = useState('start');

  return (
    <ModalWindow close={close}>
      <div className='modal-window__wrapper' onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={close} />
        {step === 'start' && <WithdrawPopupStart close={close} setStep={setStep} />}
        {step === 'success' && <WithdrawPopupSuccess close={close} />}
        {step === 'fail' && <WithdrawPopupFail close={close} />}
      </div>
    </ModalWindow>
  )
}

export default WithdrawPopup;
